import { InternalTransferCreatePage } from '@/features/internal-transfer/pages/InternalTransferCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/internal-transfer/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["internal_transfer.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: InternalTransferCreatePage,
})
